import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Footer from "../../components/default/Footer";
import Header from "../../components/default/Header";
import ActionBoxSection from "../../components/landing-page/ActionBoxSection";
import ArtikelSection from "../../components/landing-page/ArtikelSection";
import HeroSection from "../../components/landing-page/HeroSection";
import JurusanSection from "../../components/landing-page/JurusanSection";
import MentorSection from "../../components/landing-page/MentorSection";
import Testimonial from "../../components/landing-page/Testimonial";
import ClientSTART from "../../components/landing-page/ClientSTART";
import WhayUseSection from "../../components/landing-page/WhayUseSection";
import LiveCourses from "../../components/landing-page/LiveCourses";
import ContactUs from "../../components/landing-page/ContactUs";

import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const Main = () => {
	useEffect(() => {
		document.title = "LMS M-Knows";
	});

	const { user } = useSelector((state) => state.profile);

	return (
		<>
			<Header />
			<main>
				<HeroSection />
				{/* <ClientSTART /> */}
				<WhayUseSection />
				<ActionBoxSection />
				{/* <LiveCourses /> */}
				<JurusanSection />
				{/* {user?.role !== "student" ? <></> : <MentorSection />} */}
				{/* <Testimonial /> */}
				<ContactUs />
				<ArtikelSection />
			</main>
			<Footer />
		</>
	);
};

export default Main;
